import React from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Avatar from "@mui/material/Avatar";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import EmptyMessage from "../../Containers/Donations/EmptyMessage";
import { PRODUCT_ICON } from "../../common/enum/productIcon";
import CollectionDonationProductCard from "./CollectionDonationProductCard";
import { ComponentType } from "../../common/enum";

const CollectionProductsEventos = ({
  products,
  t,
  collectionProduct,
  setCollection,
  setProductError,
  componentType,
}) => {
 

  return (
    <>
      {" "}
      {products.length == 0 && <EmptyMessage message={"noProductForThisDonation"} t={t} />}
      {products !== undefined &&
        products?.map((item, index) => (
              <Box sx={{ display: "flex", alignItems: "center" , paddingBottom: "12px"}}>
                <Avatar
                  alt={
                    PRODUCT_ICON.find(
                      (itemIcon) => itemIcon.productGroup === item
                    ).productGroup
                  }
                  src={
                    PRODUCT_ICON.find(
                      (itemIcon) => itemIcon.productGroup === item
                    ).url
                  }
                  sx={{
                    width: 24,
                    height: 24,
                    ml: 0.2,
                    mr: 1,
                  }}
                />
                <Typography variant="h6">{item}</Typography>
              </Box>
        ))}
    </>
  );
};

export default CollectionProductsEventos;
